import React, { createContext, useContext, useEffect, useState } from 'react';
import * as css from './styles.module.scss';
import cx from 'classnames';

const MyContext = createContext({
	isRedirecting: 1, setIsRedirecting: () => {
	}
});

export const MyContextProvider = ({children, someProp}) => {
	const [isRedirecting, setIsRedirecting] = useState(false);
	const [isRedirectingOver, setIsRedirectingOver] = useState(false);
	
	useEffect(() => {
		if (isRedirecting) {
			setTimeout(() => {
				setIsRedirectingOver(true);
			}, 2000);
			
			setTimeout(() => {
				setIsRedirectingOver(false);
				setIsRedirecting(false);
			}, 3000);
		}
	}, [isRedirecting]);
	
	return (
		<MyContext.Provider value={{isRedirecting, setIsRedirecting}}>
			<div>
				<div
					className={cx(css.loaderFirst, isRedirecting && css.loaderVisibleFirst, isRedirectingOver && css.loaderVisibleOverFirst)}></div>
				<div
					className={cx(css.loaderSecond, isRedirecting && css.loaderVisibleSecond, isRedirectingOver && css.loaderVisibleOverSecond)}></div>
				<div
					className={cx(css.loaderThird, isRedirecting && css.loaderVisibleThird, isRedirectingOver && css.loaderVisibleOverThird)}></div>
			</div>
			
			{children}
		</MyContext.Provider>
	);
};

export const useMyContext = () => {
	return useContext(MyContext);
};

